import { Component, Inject } from '@angular/core';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { WikiService } from './wiki.service';
import { IWikiPost, WikiServiceInterface } from './wiki.interface';
import { EventsServiceInterface } from '../../services/events/events.interface';

enum Screen {
  WikiHome,
  WikiSubMenu,
  WikiPost,
}

@Component({
  selector: 'gtd-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  providers: [
    {
      provide: 'WikiServiceInterface',
      useClass: WikiService,
    },
  ],
})
@DestroySubscribers()
export class KnowledgeBaseComponent {
  public relevantPosts: IWikiPost[];
  public menuPosts: IWikiPost[];
  public currentPost: IWikiPost;
  public subMenuTitle = '';
  public searchValue = '';
  public pageTitle = '';

  public isOpened = false;
  public isLoading = false;
  public subscribers: any = {};

  public screen: Screen = Screen.WikiHome;
  public screenClass = Screen;

  constructor(
    @Inject('WikiServiceInterface') private wiki: WikiServiceInterface,
    @Inject('EventsServiceInterface') private eventsService: EventsServiceInterface
  ) {
    this.searchWiki();
    this.loadMenuPosts();

    this.subscribers.pageTitleChange = this.eventsService.on('mobileTopbarTitle:change').subscribe((data: any) => {
      if (data) {
        this.pageTitle = data.name;
        this.searchWiki(this.pageTitle);
      }
    });
    this.subscribers.docsOpen = this.eventsService.on('docs:open').subscribe(() => {
      this.open();
    });
  }

  onSearchInput(value: string): void {
    this.screen = Screen.WikiHome;
    this.searchWiki(value);
    this.loadMenuPosts();
  }

  searchWiki(searchValue?: string): void {
    this.isLoading = true;
    this.wiki.search(searchValue).subscribe((response: IWikiPost[]) => {
      this.relevantPosts = response;
      this.isLoading = false;
    });
  }

  loadMenuPosts(parentId?: number): void {
    this.isLoading = true;
    this.wiki.getPostsByParent(parentId || 0).subscribe((response: IWikiPost[]) => {
      this.menuPosts = response;
      this.isLoading = false;
    });
  }

  openPost(postId: number, postTitle: string): void {
    setTimeout(() => {
      this.screen = Screen.WikiPost;
      this.isLoading = true;
      this.wiki.getPostsByParent(postId).subscribe((listResponse: IWikiPost[]) => {
        if (listResponse.length) {
          this.menuPosts = listResponse;
          this.isLoading = false;
          this.screen = Screen.WikiSubMenu;
          this.subMenuTitle = postTitle;
        } else {
          this.wiki.getPostById(postId).subscribe((postResponse: IWikiPost) => {
            this.currentPost = postResponse;
            this.isLoading = false;
            this.screen = Screen.WikiPost;
          });
        }
      });
    }, 0);
  }

  closePost(): void {
    setTimeout(() => {
      this.screen = Screen.WikiHome;
      this.currentPost = null;
      this.searchValue = '';
      this.searchWiki(this.pageTitle);
      this.loadMenuPosts();
    }, 0);
  }

  getPostPreview(postContent: string): string {
    const textContent = postContent.replace(/<[^>]*>?/gm, '');
    return textContent.length ? textContent.slice(0, 80) + '...' : '';
  }

  open() {
    this.isOpened = true;
  }

  close() {
    this.isOpened = false;
  }
}
